import { Button } from '@collinsonx/design-system/core';
import BackButton from '@components/BackButton';
import { redirectToPreviousRoute } from 'config/navigation';
import useLocale from 'hooks/useLocale';
import useProduct from 'hooks/useProduct';
import { FC } from 'react';
import colors from 'ui/colour-constants';

import { FooterStyle } from '../enums';

const backButtonStyle = {
  label: {
    color: colors.black,
  },
  root: {
    backgroundColor: colors.white,
    border: 'solid',
    borderColor: colors.black,
    borderWidth: 2,
    color: colors.white,
  },
};

const findAnotherLoungeBackButtonStyle = {
  label: {
    color: colors.white,
  },
  root: {
    backgroundColor: colors.theme,
    border: 'solid',
    borderColor: colors.theme,
    borderWidth: 2,
    color: colors.white,
  },
};

function InternalServerErrorFooter() {
  const buttonHandler = () => {
    redirectToPreviousRoute();
  };
  const translations = useLocale();

  return (
    <>
      <Button onClick={buttonHandler}>{'Edit Booking'.toUpperCase()}</Button>
      <BackButton styles={backButtonStyle}>
        {translations.lounge.errors.server.btn.return.toUpperCase()}
      </BackButton>
    </>
  );
}

function CapacityFooter({ ctaLabel }: { ctaLabel?: string }) {
  const translations = useLocale();
  const { isFastTrackEnabled } = useProduct();

  return (
    <BackButton styles={findAnotherLoungeBackButtonStyle}>
      {ctaLabel ??
        (isFastTrackEnabled
          ? translations.fastTrack.errors.noAvailability.cta
          : translations.lounge.errors.capacity.btn.return)}
    </BackButton>
  );
}

function FlightInfoNotFoundFooter({ close }: { close: () => void }) {
  const translations = useLocale();

  return (
    <>
      <Button onClick={() => close()}>
        {translations.lounge.errors.noFlightInfoFound.btn.continue.toUpperCase()}
      </Button>
      <BackButton styles={backButtonStyle}>
        {translations.lounge.errors.noFlightInfoFound.btn.return.toUpperCase()}
      </BackButton>
    </>
  );
}

interface Props {
  capacityCtaOverride?: string;
  close: () => void;
  footerStyle: FooterStyle;
}

function LoungeClosedFooter() {
  const translations = useLocale();

  return (
    <BackButton styles={findAnotherLoungeBackButtonStyle}>
      {translations.lounge.errors.loungeClosed.btn.return}
    </BackButton>
  );
}

function MaxPeriodFooter() {
  const translations = useLocale();

  return (
    <BackButton styles={findAnotherLoungeBackButtonStyle}>
      {translations.lounge.errors.maxPeriod.btn.return}
    </BackButton>
  );
}

function MinPeriodFooter() {
  const translations = useLocale();

  return (
    <BackButton styles={findAnotherLoungeBackButtonStyle}>
      {translations.lounge.errors.minPeriod.btn.return}
    </BackButton>
  );
}

const Footer: FC<Props> = ({
  capacityCtaOverride,
  close,
  footerStyle = FooterStyle.CAPACITY,
}) => {
  switch (footerStyle) {
    case FooterStyle.CAPACITY:
      return <CapacityFooter ctaLabel={capacityCtaOverride} />;
    case FooterStyle.FLIGHT_INFO_NOT_FOUND:
      return <FlightInfoNotFoundFooter close={close} />;
    case FooterStyle.INTERNAL_SERVER_ERROR:
      return <InternalServerErrorFooter />;
    case FooterStyle.LOUNGE_CLOSED:
      return <LoungeClosedFooter />;
    case FooterStyle.MAX_PERIOD:
      return <MaxPeriodFooter />;
    case FooterStyle.MIN_PERIOD:
      return <MinPeriodFooter />;
  }
};

export default Footer;
